<template>
<!-- eslint-disable max-len -->
<div class="container">
<div class="row no-gutters">
<div class="login-form col-sm-12">

  <h2>Edit Account:</h2>

  <form>
    <div style="margin: 20px;">{{email}}</div>

    <text-input label v-model.trim="firstName" :validator="$v.firstName" required max-length autofocus>First Name</text-input>

    <text-input label v-model.trim="lastName" :validator="$v.lastName" required max-length>Last Name</text-input>

    <router-link :to="`/user/password`" class="btn btn-secondary" style="padding: 5px;">
      <span style="margin: 0 3px;">Change Password</span>
    </router-link>

    <button
      type="submit"
      class="btn"
      @click.prevent="onSubmit"
      :disabled="submitted || $v.$invalid">
      <span style="margin: 0 8px;">Confirm New Account Information</span>
    </button>
  </form>
</div>
</div>
</div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';

import TextInput from '@/components/ui/inputs/TextInput';

export default {
  components: {
    TextInput
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      submitted: false
    };
  },
  mounted() {
    this.firstName = this.me.firstName;
    this.lastName = this.me.lastName;
  },
  computed: {
    ...mapGetters([
      'me'
    ]),
    email() {
      return this.me.email;
    }
  },
  methods: {
    ...mapActions([
      'getUser',
      'updateMe',
      'flashSuccess',
      'flashDanger'
    ]),
    async onSubmit() {
      if (this.submitted) return;
      this.submitted = true;

      try {
        await this.updateMe({ firstName: this.firstName, lastName: this.lastName });

        const message = 'User updated successfully';
        this.flashSuccess({ message });
        this.submitted = false;
      } catch (_) {
        const message = 'Error updating User, please try again';
        this.flashDanger({ message });
        this.submitted = false;
      }
    }
  },
  validations: {
    firstName: {
      required,
      maxLength: maxLength(35)
    },
    lastName: {
      required,
      maxLength: maxLength(35)
    }
  }
};
</script>

<style lang="scss" scoped>
.login-form {
  background-color: white;
  margin-top: 50px;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/EditAccount.vue